import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {GlobalConstants} from '../shared/global-constants';

@Injectable({
  providedIn: 'root'
})
export class DashboardDataService {
  config;

  constructor(private readonly http: HttpClient) {}
  public readonly headerData = [
    {
      field: 'deviceStatus',
      header: '',
      type: 'statusIcon',
      colWidth: '3%',
      icon: 'pi-circle-on',
      enableSort: true,
    },
    GlobalConstants.physicalDeviceModelColDef,
    GlobalConstants.serialNumberColDef,
    GlobalConstants.serviceRegionColDef,
    GlobalConstants.productGroupColDef,
    GlobalConstants.customerColDef,
    {
      field: 'connectivityStatus',
      header: 'Connectivity Status',
      type: 'connectionStatus',
      colWidth: '10%',
      enableSort: true,
    },
    {
      field: 'latestAlarmCreatedOn',
      header: 'Last Alarm',
      type: 'date',
      colWidth: '13%',
      enableSort: true,
    },
    {
      field: 'lastViewed',
      header: 'Last Viewed',
      type: 'date',
      colWidth: '12%',
      enableSort: true,
    },
  ];

  getConfig(): Observable<any[]> {
    const url = `${environment.baseUrl}${environment.getConfig}`;
    return this.http.get<any[]>(url, { withCredentials: false });
  }

  // get dashboard KPIs count
  getDashboardKPIs(): Observable<any[]> {
    const url = environment.baseUrl + environment.getDashboardKPIs;
    return this.http.get<any[]>(url, { withCredentials: false });
  }

  setConfig(configuration): void {
    this.config = configuration;
  }
}
